/* Переиспользуемая иконка-кнопка без текста (редактировать, удалить, закрыть и т.д.) */
.icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  border-radius: var(--r-sm);
  background: transparent;
  color: var(--text-muted);
  cursor: pointer;
  transition: var(--btn-transition);
  flex-shrink: 0;
}

.icon-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

@media (hover: hover) {
  .icon-btn:not(.icon-btn_danger):hover:not(:disabled) {
    background: color-mix(in srgb, var(--accent) 15%, transparent);
    color: var(--accent);
  }

  .icon-btn.icon-btn_danger:hover:not(:disabled) {
    background: var(--hover-bg-danger);
    color: var(--accent-error);
  }
}
